import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { events } from "@/mocks/events";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategoriesSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="w-full">
        <SectionHeading
          kicker="主题分类"
          title="按你关心的领域追瓜"
          desc="不同圈层的热点逻辑差别很大，分类查看能更快找到你真正关心的那条故事线。"
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {categories.map((cat) => {
            const count = events.filter((e) => e.categorySlug === cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/events?cat=${cat.slug}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors duration-200 hover:border-primary-300 cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 text-xl transition-colors duration-200 group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className={cat.icon} />
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {count} 个事件
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {cat.name}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                  进入分类
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </span>
                </span>
              </Link>
            );
          })}

          <Link
            to="/events"
            className="flex flex-col justify-between rounded-lg border border-dashed border-primary-300 bg-primary-50 p-5 transition-colors duration-200 hover:bg-primary-100 cursor-pointer"
          >
            <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl">
              <i className="ri-apps-2-line" />
            </span>
            <div>
              <h3 className="mt-4 font-heading text-base font-bold text-primary-800">
                浏览全部事件
              </h3>
              <p className="mt-1.5 text-xs leading-relaxed text-primary-700">
                不分领域，按热度与更新时间查看所有已梳理事件。
              </p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}